<template>
  <a-drawer
    title="分发"
    width="700"
    :visible="visible"
    :closable="false"
    @close="onClose"
  >
    <!-- from -->
    <a-form
      ref="RefForm"
      :model="formState"
      :label-col="{ span: 6 }"
      :wrapper-col="{ span: 16 }"
    >
      <!-- 项目类型 -->
      <a-form-item>
        <template #label>
          批量分发项目
          <a-tooltip>
            <template #title>仅用于批量选中项目，没有其他用处，不会提交服务器。</template>
            <info-circle-outlined style="color: #555; margin-left: 4px; cursor: pointer;" />
          </a-tooltip>
        </template>
        <a-select
          v-model:value="formState.projectType"
          placeholder="请选择"
          allow-clear
          @change="handleProjectTypeChange"
        >
          <a-select-option value="iaa">IAA</a-select-option>
          <a-select-option value="iap">IAP</a-select-option>
        </a-select>
      </a-form-item>
      <!-- 分发项目 -->
      <a-form-item
        label="分发项目"
        name="project"
        :rules="[{ required: true }]"
      >
        <a-select
          v-model:value="formState.project"
          placeholder="请选择"
          mode="multiple"
          show-search
          :disabled="!!recordID"
          :filter-option="filterOption"
          :getPopupContainer="(triggerNode) => triggerNode.parentNode"

        >
          <a-select-option
            v-for="item in pList"
            :key="`${item.id}-${item.name}`"
            :value="item.id"
          >
            {{ item.name }}
          </a-select-option>
        </a-select>
      </a-form-item>
      <!-- 竖版封面 -->
      <!-- <a-form-item
        label="竖版封面"
        name="verticalCover"
        :rules="[{ required: true, validator: validator }]"
      >
        <a-form-item-rest>
          <Upload
            accept=".png,.jpg,.gif"
            uploadSource="BaseInfo"
            :fileNumber="5"
            :beforeUploadPro="beforeUploadPro"
            :fileList="formState.verticalCover"
            :uploadBucket="$pub.BUCKET_PUB()"
          />
        </a-form-item-rest>
        <div class="form-upload-hint">支持.png .jpg .gif</div>
        <div class="form-upload-list" v-if="formState.verticalCover.length">
          <ImageView
            class="form-upload-item"
            v-for="(item, index) in formState.verticalCover"
            :key="index"
            :url="$pub.CDN_URL(item.url)"
            :fileJson="item"
            @delete="touchDeleteCover('verticalCover', index)"
          >
            <a-form-item class="checkbox-form">
              <a-checkbox
                v-model:checked="item.is_choose_boolean"
                class="upload-item-select"
                @change="changeSelectCover('verticalCover', index)"
              >
              </a-checkbox>
            </a-form-item>
          </ImageView>
        </div>
      </a-form-item> -->
      <!-- 横版封面 -->
      <!-- <a-form-item
        label="横版封面"
        name="horizontalCover"
      >
        <a-form-item-rest>
          <Upload
            accept=".png,.jpg,.gif"
            uploadSource="BaseInfo"
            :fileNumber="5"
            :imgSizeMode="22"
            :imgSizeWidth="208"
            :imgSizeHeight="124"
            imgSizeError="图片最小尺寸为 208 * 124"
            :imgScaleMode="1"
            :imgScaleWidth="208"
            :imgScaleHeight="124"
            imgScaleError="图片尺寸比例不正确"
            :beforeUploadPro="beforeUploadPro"
            :fileList="formState.horizontalCover"
            :uploadBucket="$pub.BUCKET_PUB()"
          />
        </a-form-item-rest>
        
        <div class="form-upload-hint">支持.png .jpg .gif，208×124，或尺寸更大的等比图片</div>
        <div class="form-upload-list" v-if="formState.horizontalCover.length">
          <ImageView
            class="form-upload-item horizontal"
            v-for="(item, index) in formState.horizontalCover"
            :key="index"
            :url="$pub.CDN_URL(item.url)"
            :fileJson="item"
            @delete="touchDeleteCover('horizontalCover', index)"
          >
            <a-form-item class="checkbox-form">
              <a-checkbox
                v-model:checked="item.is_choose_boolean"
                class="upload-item-select"
                @change="changeSelectCover('horizontalCover', index)"
              >
              </a-checkbox>
            </a-form-item>
          </ImageView>
        </div>
      </a-form-item> -->
      <!-- 视频集锦 -->
      <!-- <a-form-item
        label="视频集锦"
        name="videoHighlight"
        :rules="[{ required: true, validator: validator }]"
      >
        <a-form-item-rest>
          <Upload
            accept=".mp4"
            uploadSource="video_highlight"
            :fileNumber="5"
            :beforeUploadPro="beforeUploadVideoPro"
            :fileList="formState.videoHighlight"
            :uploadBucket="$pub.BUCKET_PUB()"
          />
        </a-form-item-rest>
        <div class="form-upload-hint">支持.mp4，2分钟之内的视频，主要用作付费引导</div>
        <div class="form-upload-list" v-if="formState.videoHighlight.length">
          <ImageView
            class="form-upload-item"
            v-for="(item, index) in formState.videoHighlight"
            :key="index"
            :isShowPlay="true"
            :url="$pub.CDN_URL(item.url)"
            :fileJson="item"
            @delete="touchDeleteVideo(index)"
            @play="touchPlayVideo(index, item)"
          >
            <a-form-item class="checkbox-form">
              <a-checkbox
                v-model:checked="item.is_choose_boolean"
                class="upload-item-select"
                @change="changeSelectCover('videoHighlight', index)"
              >
              </a-checkbox>
            </a-form-item>
          </ImageView>
        </div>
      </a-form-item> -->
      <!-- 剧情标签 -->
      <a-form-item
        label="剧情标签"
        name="plotTag"
      >
        <a-select
          mode="multiple"
          placeholder="请选择"
          v-model:value="formState.plotTag"
          :filterOption="filterOption"
        >
          <a-select-option
            v-for="tag in tags"
            :key="`${tag.id}-${tag.name}`"
            :value="tag.id"
          >
            {{ tag.name }}
          </a-select-option>
        </a-select>
      </a-form-item>
      <!-- 封面角标 -->
      <a-form-item
        label="封面角标"
        name="cornerMark"
      >
        <a-select
          v-model:value="formState.cornerMark"
          placeholder="请选择"
        >
          <!-- 手动清除角标 -->
          <a-select-option :value="0">无</a-select-option>
          <a-select-option
            v-for="mask in CornerMasks"
            :key="mask.value"
            :value="mask.value"
          >
            {{ mask.text }}
          </a-select-option>
        </a-select>
      </a-form-item>
      <!-- 基础权重 -->
      <a-form-item
        label="基础权重"
        name="basicWeight"
        :rules="[{ required: true, validator: validator }]"
      >
        <a-input
          placeholder="请输入1-1000，支持2位小数"
          v-model:value="formState.basicWeight"
        />
      </a-form-item>
      <!-- 基础播放量 -->
      <a-form-item
        label="基础播放量"
        name="basicPlayNum"
        :rules="[{ required: true, message: '请输入基础播放量' }]"
      >
        <a-input
          style="width: 200px; margin-right: 10px;"
          placeholder="请输入"
          v-model:value="formState.basicPlayNum"
        />
        <a class="a-link" @click="setBasicPlayNum(1000)">千级</a>
        <a class="a-link" @click="setBasicPlayNum(10000)">万级</a>
        <a class="a-link" @click="setBasicPlayNum(100000)">十万级</a>
        <a class="a-link" @click="setBasicPlayNum(1000000)">百万级</a>
      </a-form-item>
      <!-- 付费起始 -->
      <!-- <a-form-item
        class="form-item-clear"
        label="付费起始"
        :rules="[{ required: true }]"
      >
        <a-row>
          <a-col :span="12">
            <a-form-item
              name="payFrom"
              :rules="[{ required: true, validator: validator }]"
            >
              <a-input
                style="width: 200px; margin-right: 18px;"
                placeholder="请输入"
                suffix="集起"
                v-model:value="formState.payFrom"
                :disabled="formState.payFromChecked"
              />
            </a-form-item>
          </a-col>
        </a-row>
      </a-form-item> -->
      <!-- 每集收费 -->
      <a-form-item
        class="form-item-clear"
        label="每集收费"
        :rules="[{ required: true }]"
      >
        <a-row>
          <!-- 自定义 -->
          <a-col :span="12">
            <a-form-item
              name="perPay"
              :rules="[{ required: true, validator: validator }]"
            >
              <a-input
                style="width: 200px; margin-right: 18px;"
                placeholder="请输入"
                suffix="嗨豆"
                v-model:value="formState.perPay"
                :disabled="formState.perPayChecked"
              />
            </a-form-item>
          </a-col>
        </a-row>
      </a-form-item>
      <!-- 广告解锁 -->
      <a-form-item
        label="广告解锁"
        name="ad_unlock"
      >
        <a-switch v-model:checked="formState.ad_unlock" :disabled="formState.ad_unlock_disabled" />
      </a-form-item>
      <!-- 下部轮播 -->
      <!-- <a-form-item
        label="下部轮播"
        name="nextDramaID"
        :rules="[{ required: true, message: '请选择' }]"
      >
        <a-select
          show-search
          style="width: 200px;"
          v-model:value="formState.nextDramaID"
          placeholder="请选择"
          :filter-option="filterOption"
        >
          <a-select-option
            v-for="item in dramas"
            :key="`${item.project_drama_id}-${item.remark_name}`"
            :value="item.project_drama_id"
          >
            {{ item.remark_name }}
          </a-select-option>
        </a-select>
      </a-form-item> -->
      <!-- 上架状态 -->
      <a-form-item
        label="上架状态"
        name="shelfChecked"
      >
        <a-switch v-model:checked="formState.shelfChecked" />
      </a-form-item>
      <!-- 前台首页展示 -->
      <a-form-item
        label="前台首页展示"
        name="isShow"
      >
        <a-switch v-model:checked="formState.isShow" />
      </a-form-item>
      <!-- 达人推广 -->
      <a-form-item
        label="达人推广"
        name="talent_promotion"
      >
        <a-switch v-model:checked="formState.talent_promotion" />
      </a-form-item>
      <!-- 达人素材 -->
      <a-form-item
        v-if="formState.talent_promotion"
        label="达人素材"
        name="talent_material"
        :rules="[{ required: true }]"
      >
        <a-select
          v-model:value="formState.talent_material"
          placeholder="请选择"
        >
          <a-select-option
            v-for="mask in TalentMaterials"
            :key="mask.value"
            :value="mask.value"
          >
            {{ mask.text }}
          </a-select-option>
        </a-select>
      </a-form-item>
    </a-form>
    <!-- 尾部 -->
    <template #footer>
      <div class="footer-view">
        <span class="footer-hint" v-if="selectKeys.length > 1">共选择了{{ selectKeys.length }} 部短剧</span>
        <div style="flex: 1;"></div>
        <a-button style="margin-right: 8px" @click="onClose">取消</a-button>
        <a-button type="primary" @click="touchSubmit">确定</a-button>
      </div>
    </template>
    <!-- 加载 -->
    <Loading :loading="isLoading"></Loading>
  </a-drawer>
</template>

<script setup>
import { reactive, ref } from 'vue'
import { nextTick } from 'process'
import { message } from 'ant-design-vue'
import { ClassifySettings, CornerMasks, TalentMaterials } from '@/utils/constantList'
import Loading from '@/components/Loading'
import Pub from '@/utils/public'
import dayjs from 'dayjs'
import { dramaDistribute, projectList, distributeDetail, distributeEdit } from '@/api/copyright'
import { getAllClassifyList } from '@/api/system'
import { projectDramaAll } from '@/api/operate'

// emit
const emit = defineEmits(['success'])
// from
const RefForm = ref(null)
// 显示
let visible = ref(false)
// 加载
let isLoading = ref(false)
// 选中的影剧列表
let selectKeys = ref([])
// 编辑的分发记录id
let recordID = ref(undefined)
// 项目列表
let pList= ref([])
// 标签列表
let tags = ref([])
// 短剧列表
let dramas = ref([])
// 日期格式
const dateFormat = 'YYYY-MM-DD'
// 表单参数
const formState = reactive({
  // 项目类型（不提交到服务器）
  projectType: undefined,
  // 分发项目
  project: [],
  // 竖版封面
  // verticalCover: [],
  // 横版封面
  // horizontalCover: [],
  // 视频集锦
  // videoHighlight: [],
  // 剧情标签
  plotTag: [],
  // 封面角标
  cornerMark: undefined,
  // 基础权重
  basicWeight: undefined,
  // 基础播放量
  basicPlayNum: undefined,
  // 下部轮播
  // nextDramaID: undefined,
  // 付费起始集数
  // payFrom: undefined,
  //  付费起始勾选默认
  payFromChecked: false,
  // 每集收费
  perPay: undefined,
  // 每集收费勾选默认
  perPayChecked: false,
  // 广告解锁
  ad_unlock: false,
  // 上架状态勾选
  shelfChecked: false,
  // 前台首页展示
  isShow: false,
  // 达人推广
  talent_promotion: false,
  // 达人素材
  talent_material: undefined
})

// 显示
function showDrawer ({ keys, id, fixedExclusive }) {
  // 初始化默认值
  formState.basicWeight = 1000
  formState.perPay = 220
  formState.shelfChecked = true
  formState.isShow = true
  // 多选新建分发时，用到 keys
  selectKeys.value = keys || []
  // 单个分发记录编辑时，用到id
  recordID.value = id || undefined
  // 显示
  visible.value = true
  // 获取标签列表（获取详情 必须在 获取标签成功 以后，兼容已停用标签问题）
  getTags()
  // 获取剧集列表
  getProjectDramaAll()
  // 获取项目列表
  getProjectList()
  // 获取分发详情
  // if (id) {
  //   getDistributeDetail()
  // }
}

// 不可选中当天之前的日期（今日可选中）
// function disabledDate (current) {
//   return current && current < dayjs().subtract(1, 'days').endOf('day')
// }

// 获取项目列表
function getProjectList () {
  projectList().then(res => {
    isLoading.value = false
    const { code, msg, data } = res
    if (code === 0) {
      pList.value = data
    } else {
      message.error(res.message || msg)
    }
  })
}

// 处理项目类型切换
function handleProjectTypeChange (value) {
  if (!value) {
    // 清空时，清空选中的项目
    formState.project = []
    return
  }
  
  if (!pList.value || pList.value.length === 0) {
    return
  }
  
  // 根据项目类型自动选中对应的分发项目
  const selectedProjectIds = []
  
  if (value === 'iaa') {
    // IAA: 选中项目名称（转小写）包含 "iaa" 的项目
    pList.value.forEach(item => {
      if (item.name && item.name.toLowerCase().includes('iaa')) {
        selectedProjectIds.push(item.id)
      }
    })
  } else if (value === 'iap') {
    // IAP: 选中项目名称（转小写）不包含 "iaa" 的项目
    pList.value.forEach(item => {
      if (item.name && !item.name.toLowerCase().includes('iaa')) {
        selectedProjectIds.push(item.id)
      }
    })
  }
  
  formState.project = selectedProjectIds
}

// 获取标签列表
function getTags () {
  const params = {
    source: ClassifySettings.tag,
    // 1 隐藏停用
    status: 1,
    page: 1,
    page_size: 10000
  }
  getAllClassifyList(params).then(res => {
    const { code, msg, data } = res
    if (code === 0) {
      tags.value = data.list
    } else {
      message.error(res.message || msg)
    }
  })
}

// 短剧列表
function getProjectDramaAll () {
  projectDramaAll().then(res => {
    const { code, data } = res
    if (code === 0) {
      dramas.value = data
    }
  })
}

// // 获取分发详情
// function getDistributeDetail () {
//   distributeDetail({
//     id: recordID.value
//   }).then(res => {
//     isLoading.value = false
//     const { code, msg, data } = res
//     if (code === 0) {
//       // 设置表单显示
//       nextTick(() => {
//         // 分发项目
//         formState.project = data.project_ids
//         // 合作方式
//         formState.settlement = data.cop_type
//         // 价格
//         formState.price = Pub.KEEP_NUMBER_DECIMAL(data.money / 100, 2)
//         // 分成比例
//         formState.proportion = data.cop_type === 1 ? undefined : data.cop_rate
//         // 授权开始
//         formState.copyrightTermStart = data.copyright_start_at ? dayjs(data.copyright_start_at) : undefined
//         // 授权结束
//         formState.copyrightTermEnd = data.copyright_end_at ? dayjs(data.copyright_end_at) : undefined
//         // 是否独家
//         formState.exclusive = data.is_unique_auth
//       })
//     } else {
//       message.error(res.message || msg)
//     }
//   })
// }

// 关闭
function onClose () {
  if (!isLoading.value) {
    visible.value = false
    resetFields()
  }
}

// 重置
function resetFields () {
  RefForm.value.resetFields()
}

// 模糊匹配
function filterOption (input, option) {
  return `${option.key}`.toLowerCase().includes(`${input || ''}`.toLowerCase())
}

// 提交
function touchSubmit () {
  RefForm.value.validate().then(() => {
    isLoading.value = true
    // let params = {}
    // if (recordID.value) {
    //   // 编辑分发
    //   params = {
    //     id: recordID.value,
    //     cop_type: formState.settlement,
    //     money: formState.price ? formState.price * 100 : undefined,
    //     cop_rate: formState.proportion,
    //     copyright_end_at: formState.copyrightTermEnd ? formState.copyrightTermEnd.format(dateFormat) : undefined,
    //     is_unique_auth: formState.exclusive,
    //   }
    // } else {
    //   // 新建分发
    //   params = {
    //     project_ids: formState.project,
    //     drama_ids: selectKeys.value,
    //     cop_type: formState.settlement,
    //     money: formState.price ? formState.price * 100 : undefined,
    //     cop_rate: formState.proportion,
    //     copyright_start_at: formState.copyrightTermStart ? formState.copyrightTermStart.format(dateFormat) : undefined,
    //     copyright_end_at: formState.copyrightTermEnd ? formState.copyrightTermEnd.format(dateFormat) : undefined,
    //     is_unique_auth: formState.exclusive,
    //   }
    // }
    // // 按需执行函数
    // const Func = recordID.value ? distributeEdit : dramaDistribute
    // Func(params).then(res => {
    //   isLoading.value = false
    //   const { code, msg, data } = res
    //   if (code === 0) {
    //     message.success('操作成功')
    //     onClose()
    //     emit('success')
    //   } else {
    //     message.error(res.message || msg)
    //   }
    // })
    // 根据布尔值处理封面选中
    // formState.verticalCover.forEach(item => {
    //   item.is_choose = item.is_choose_boolean ? 1 : 0
    // })
    // formState.horizontalCover.forEach(item => {
    //   item.is_choose = item.is_choose_boolean ? 1 : 0
    // })
    // 视频集锦处理
    // formState.videoHighlight.forEach(item => {
    //   item.is_choose = item.is_choose_boolean ? 1 : 0
    // })
    // 准备数据
    const params = {
      drama_ids: selectKeys.value,
      project_ids: formState.project,
      // s_cover: formState.verticalCover,
      // h_cover: formState.horizontalCover,
      // highlights: formState.videoHighlight,
      tag_ids: formState.plotTag,
      cover_tag: formState.cornerMark,
      weight: formState.basicWeight,
      // next_project_drama_id: formState.nextDramaID,
      play_count: formState.basicPlayNum,
      // start_pay_eq: formState.payFrom,
      fee: formState.perPay,
      default_pay_button: formState.payFromChecked ? 1 : 0,
      default_fee_button: formState.perPayChecked ? 1 : 0,
      ad_unlock: formState.ad_unlock ? 1 : 0,
      status: formState.shelfChecked ? 1 : 0,
      is_show: formState.isShow ? 1 : 0,
      talent_promotion: formState.talent_promotion ? 1 : 0,
      talent_material: formState.talent_material,
      // copyright_start_at: detail.value.copyright_start_at,
      // copyright_end_at: detail.value.copyright_end_at
    }
    dramaDistribute(params).then(res => {
      isLoading.value = false
      const { code, msg, data } = res
      if (code === 0) {
        message.success('操作成功')
        onClose()
        emit('success')
      } else {
        message.error(res.message || msg)
      }
    })
  }).catch((err) => {
    console.log(err)
  })
}

// 设置基础播放量随机数
function setBasicPlayNum (level) {
  formState.basicPlayNum = Pub.RANDOM(level)
}

// 效验 - 价格
function validatorPrice (rule, value) {
  if (!value) {
    // return Promise.reject('请输入')
    return Promise.resolve()
  } else if (!Pub.REG_IS_INTEGER_OR_FLOAT(value)) {
    return Promise.reject('必须为正数，且最多保留两位小数')
  }
  return Promise.resolve()
}
// 效验 - 分成比例
function validatorProportion (rule, value) {
  if (!value) {
    // return Promise.reject('请输入')
    return Promise.resolve()
  } else if (!Pub.REG_IS_NUMBER(value)) {
    return Promise.reject('必须为正数')
  } else if (Pub.CHECK_NUMBER_DECIMAL(value, 2)) {
    return Promise.reject('最多 2 位小数')
  }
  return Promise.resolve()
}

// 表单校验
function validator (rule, value) {
  // 封面
  if (rule.field === 'verticalCover') {
    if (value && value.length === 0) {
      return Promise.reject('请上传封面')
    }
    if (!value.some(item => item.is_choose_boolean)) {
      return Promise.reject('必须选中一个封面')
    }
    return Promise.resolve()
  }
  // 视频集锦
  // if (rule.field === 'videoHighlight') {
  //   if (value && value.length === 0) {
  //     return Promise.reject('请上传视频集锦')
  //   }
  //   if (!value.some(item => item.is_choose_boolean)) {
  //     return Promise.reject('必须选中一个视频集锦')
  //   }
  //   return Promise.resolve()
  // }
  // 付费起始（不得大于短剧总集数）
  else if (rule.field === 'payFrom') {
    // 若勾选默认，则不校验
    if (formState.payFromChecked) {
      return Promise.resolve()
    }
    // 否则校验自身
    if (!value) {
      return Promise.reject('请输入付费起始')
    } else if (!Pub.REG_IS_POSITIVE_INTEGER(value)) {
      return Promise.reject('必须为正整数')
    }
    // else if (value > detail.value.drama.total_ep + 1) {
    //   return Promise.reject('不得大于短剧总集数 + 1')
    // }
    // else if (value > detail.value.drama.total_ep) {
    //   return Promise.reject('不得大于短剧总集数')
    // }
    return Promise.resolve()
  }
  // 每集收费（必须为偶数）
  else if (rule.field === 'perPay') {
    // 若勾选默认，则不校验
    if (formState.perPayChecked) {
      return Promise.resolve()
    }
    // 否则校验自身
    if (!value) {
      return Promise.reject('请输入每集收费')
    } else if (!Pub.REG_IS_POSITIVE_INTEGER(value)) {
      return Promise.reject('必须为正整数')
    } else if (!Pub.IS_EVEN_NUMBER(value)) {
      return Promise.reject('必须为偶数')
    }
    return Promise.resolve()
  }
  // 基础权重
  else if (rule.field === 'basicWeight') {
    if (!value) {
      return Promise.reject('请输入基础权重')
    } else if (!Pub.REG_IS_INTEGER_OR_FLOAT(value) || value > 1000 || value < 1) {
      return Promise.reject('必须为1-1000，支持2位小数')
    }
    return Promise.resolve()
  }
}

// 抛出
defineExpose({
  showDrawer
})

</script>

<style scoped>
.form-input {
  width: 50%;
}
.form-item-clear {
  margin-bottom: 0;
}
.footer-view {
  display: flex;
  align-items: center;
}
.footer-hint {
  color: #5A5A5A;
}
.a-link {
  margin-left: 8px;
}
</style>